<template>
    <div class="mx-auto max-w-[1126px] px-4 s:px-6">
        <slot />
    </div>
</template>
